






















import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import IClose from '@/components/icons/IClose.vue'

@Component({
  name: "tooltip",
  components: {
    IClose,
  },
})
export default class Search extends Vue {
  @Prop({type: [String], default: ''}) title !:any
  @Prop({type: [String], default: ''}) text !:any
  @Prop({type: [String], default: '265px'}) width !:any
  @Prop({type: [Boolean], default: false}) left !:any
  @Prop({type: [Boolean], default: false}) top !:any
  @Prop({type: [Boolean], default: false}) right !:any
  @Prop({type: [Boolean], default: false}) bottom !:any
  @Prop({type: [Boolean], default: false}) center !:any
  @Prop({type: [Boolean], default: false}) bottomArrow !:any
  @Prop({type: [Boolean], default: false}) show !:any

  showTooltip:boolean = true

  @Watch('show')
  toggleShow() {
    this.showTooltip = this.show
  }

  mounted() {
    this.showTooltip = this.show
  }

}
